export default __webpack_public_path__ + "b5cb1b3463d5147f7bafb991cb91383e.wav";